import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import { configShop } from '../../states/configShop';
import { userOrder } from '../../states/userOrder';
export const NewHome2 = ({
  backgroundColor,
}) => {
  let navigate = useNavigate();
  const { dataConfig } = configShop();
  const { setDataUser, dataUser } = userOrder();
  localStorage.setItem("mostrarPopUp", true);
  const OnLink = (item) => {
    if (item.type_integration === '1') {
      setDataUser({
        deliveryMethod: 1,
        popAddress: dataUser.city == 0
      })
      localStorage.setItem("typeSend", 0);
      localStorage.setItem("pleiztUuid", window.location.hostname.split(".")[0]);
      navigate("/menu");
    } else if (item.type_integration === "2") {
      localStorage.setItem("typeSend", 1);
      localStorage.setItem("pleiztUuid", window.location.hostname.split(".")[0]);
      setDataUser({
        deliveryMethod: 2,
        popAddress: (dataUser?.shopData ?? []).length === 0
      })
      navigate("/menu");
    } else if (item.type_integration === "3") {
      localStorage.setItem("typeSend", 2);
      setDataUser({
        deliveryMethod: 0,
      })
      navigate("/menu-local");
    } else if (item.type_integration === "4") {
      navigate("/sedes");
    } else if (item.type_integration === '5') {
      window.open(item.link, '_blank');
    } else {
      window.open(item.link, '_blank');
    }
  };

  return (
    <React.Fragment>
      <div
        className="container-new-principal-home"
        style={{
          background: backgroundColor,
        }}
      >
        <section className="container-options-home">
          {dataConfig?.page_home?.buttons?.map((item, i) => {
            return (
              <button key={item.uuid ?? i} onClick={() => OnLink(item)} className="boton-home-v2" style={{ "--btn-color": item?.color, "--btn-text-color": item?.text_color }}>
                <p className="boton-title-v2">{item.text}</p>
              </button>
            )
          })}
        </section>
      </div>
    </React.Fragment>
  );
};